var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$attrs.slug)?_c('vuetify-ad',{attrs:{"slug":_vm.$attrs.slug,"medium":"exit-ad"}}):_c('bsa-ad',{attrs:{"medium":"exit-ad"}})
}
var staticRenderFns = []

export { render, staticRenderFns }